/**
 * Is empty string
 *
 * @param {unknown} value
 * @returns {boolean} Whether the value is an empty string
 */
export const isEmptyString = (value: unknown): boolean => value === '';
